import { pdStore } from "../store/mini-rx.store.js";
import { selectAuthUser } from "../store/spa-app-selector.js";
import { AsyncDirective, directive } from "lit/async-directive.js";
//#region src/auth/auth-directives.ts
/**
* Base class for auth directives - handles store subscription
*/
var AuthDirectiveBase = class extends AsyncDirective {
	constructor(..._args) {
		super(..._args);
		this.authCheckComplete = false;
	}
	disconnected() {
		this.subscription?.unsubscribe();
	}
	reconnected() {
		this.subscribe();
	}
	subscribe() {
		if (this.subscription) return;
		const store = pdStore();
		if (!store) return;
		this.subscription = store.select(selectAuthUser).subscribe(({ user, loginCheckFinish }) => {
			this.user = user;
			this.authCheckComplete = loginCheckFinish;
			this.setValue(this.computeValue());
		});
	}
};
/**
* ifAuth - renders content only if user is logged in
*
* @example
* ${ifAuth(html`<user-menu></user-menu>`)}
* ${ifAuth(html`<profile-link></profile-link>`, html`<login-button></login-button>`)}
*/
var IfAuthDirective = class extends AuthDirectiveBase {
	render(content, fallback) {
		this.content = content;
		this.fallback = fallback ?? "";
		this.subscribe();
		return this.computeValue();
	}
	computeValue() {
		if (!this.authCheckComplete) return this.fallback ?? "";
		return this.user ? this.content ?? "" : this.fallback ?? "";
	}
};
/**
* ifRole - renders content only if user has at least one of the specified roles
*
* @example
* ${ifRole('admin', html`<admin-panel></admin-panel>`)}
* ${ifRole(['admin', 'editor'], html`<edit-btn></edit-btn>`, html`<span>Read only</span>`)}
*/
var IfRoleDirective = class extends AuthDirectiveBase {
	constructor(..._args2) {
		super(..._args2);
		this.roles = [];
	}
	render(roles, content, fallback) {
		this.roles = Array.isArray(roles) ? roles : [roles];
		this.content = content;
		this.fallback = fallback ?? "";
		this.subscribe();
		return this.computeValue();
	}
	computeValue() {
		if (!this.authCheckComplete) return this.fallback ?? "";
		return this.roles.some((role) => this.user?.claims?.[role] === true) ? this.content ?? "" : this.fallback ?? "";
	}
};
/**
* ifNotAuth - renders content only if user is NOT logged in
*
* @example
* ${ifNotAuth(html`<login-button></login-button>`)}
*/
var IfNotAuthDirective = class extends AuthDirectiveBase {
	render(content, fallback) {
		this.content = content;
		this.fallback = fallback ?? "";
		this.subscribe();
		return this.computeValue();
	}
	computeValue() {
		if (!this.authCheckComplete) return this.fallback ?? "";
		return !this.user ? this.content ?? "" : this.fallback ?? "";
	}
};
var ifAuth = directive(IfAuthDirective);
var ifRole = directive(IfRoleDirective);
var ifNotAuth = directive(IfNotAuthDirective);
//#endregion
export { ifAuth, ifNotAuth, ifRole };
